import type { GearSlot } from '@lastday/shared';

/**
 * Line icons for the equipment slots (24×24), from the profile design. Gloves,
 * accessory and pants are drawn to match. Also the fallback when an item icon is missing.
 */
export const SLOT_ICON: Record<GearSlot, string> = {
  helmet: 'M4 16 A8 8 0 0 1 20 16 Z M2 16 H22',
  body: 'M8 3 L12 6 L16 3 L21 8 V20 H3 V8 Z',
  gloves: 'M7 21 V13 L4.5 9.5 C3.8 8.4 5.2 7.2 6.2 8.1 L8 10 V5 C8 3.7 10 3.7 10 5 V10 M10 4.5 C10 3.2 12 3.2 12 4.5 V10 M12 5 C12 3.7 14 3.7 14 5 V10.5 M14 6.5 C14 5.2 16 5.2 16 6.5 V14 C16 18 14.5 21 11.5 21 Z',
  pants: 'M6 3 H18 L19.5 21 H14 L12 10 L10 21 H4.5 Z M6 6.5 H18',
  boots: 'M7 3 H12 V14 L20 16 V20 H4 V14 Z',
  weapon: 'M5 21 L17 5 M17 5 C 17 2 21 2 21 5 C 21 7 19 8 18 7',
  backpack: 'M8 6 H16 A3 3 0 0 1 19 9 V18 A3 3 0 0 1 16 21 H8 A3 3 0 0 1 5 18 V9 A3 3 0 0 1 8 6 Z M9 6 V4 H15 V6 M8 13 H16',
  accessory: 'M7 3 L12 10 L17 3 M12 10 A5 5 0 1 1 11.99 10 Z',
};
